module.exports = __webpack_public_path__ + "/fonts/404.6565b0e.svg";